import * as commonActions from "../constants/common";

const initialState = {
  encryptionKey: "7a91c568-311f-4d88-aed6-3c0117ca6c6b-cf6e6e93-28ed-4960-9faf-38fee2583455",
  errorMessage: "",
  isLoading: false,
  isLoggedIn: false,
  stepper: { activeStep: 0 },
  welcomeKitData: {
    showConfirm: true,
    showBundles: true,
    showTawuniyaDrive: true,
    showTawuniyaMobile: true,
    showSafety: true,
    thankMsg: "Your insurance policy is confirmed!",
    applicationName: "",
    applicantName: "",
    idNumber: "",
    email: "",
    policyNo: "",
    beginDate: "",
    downloadLink: "",
    manageLink: "",
    expireDate: "",
    policyType: "",
    claimPolicy: "",
    hasExposure: false,
    otherInfo: {},
    declarationsData: {},
  },
  JWT: "",
  requestId:"",
};

export default function commonReducer(state = initialState, action) {
  switch (action.type) {
    case commonActions.UPDATE_IS_LOGIN:
      return { ...state, isLoggedIn: action.payload };
    case commonActions.UPDATE_LOADING:
      return { ...state, isLoading: action.payload };
    case commonActions.SHOW_ERROR_MESSAGE:
      return { ...state, errorMessage: action.payload };
    case commonActions.SET_ACTIVE_STEP:
      return { ...state, stepper: action.payload };
    case commonActions.UPDATE_WELCOME_KIT_DETAILS:
      return { ...state, welcomeKitData: action.payload };
    case commonActions.SET_POLICY_TYPE:
      return {
        ...state,
        policyType: action.payload,
      };
    case commonActions.SET_CLAIM_POLICY:
      return {
        ...state,
        claimPolicy: action.payload,
      };
    case commonActions.HAS_EXPOSURE:
      return {
        ...state,
        hasExposure: action.payload,
      };
    case commonActions.SET_OTHER_INFO:
      return {
        ...state,
        otherInfo: action.payload,
      };
    case commonActions.SET_DEC_DATA:
      return {
        ...state,
        declarationsData: action.payload,
      };
    case commonActions.SET_JWT:
      return {
        ...state,
        JWT: action.payload,
      };
    case commonActions.SET_REQUEST_ID:
      return {
        ...state,
        requestId: action.payload,
      };
    default:
      return state;
  }
}
